export type DialogStackEintrag = {
  /** Liefert, ob dieser Dialog der oberste im Vuetify-Overlay-Stapel ist. */
  isGlobalTop: () => boolean
  close: () => void
  /** Solange dies `true` liefert, bleibt der Dialog offen (z.B. während des Speicherns). */
  blocked?: () => boolean
}

const eintraege = new Set<DialogStackEintrag>()

export function registriereDialog (eintrag: DialogStackEintrag): () => void {
  eintraege.add(eintrag)
  return () => { eintraege.delete(eintrag) }
}

export function obersterDialog (): DialogStackEintrag | undefined {
  for (const eintrag of eintraege) {
    if (eintrag.isGlobalTop()) return eintrag
  }
  return undefined
}
